// extracted by mini-css-extract-plugin
export default {"blog__card":"BlogCard_blog__card__SEHjI","blog__img":"BlogCard_blog__img__gBnMJ","blog__content":"BlogCard_blog__content__zToLp","detailBtn":"BlogCard_detailBtn__zu3Lu"};